"use client";
import { useEffect, useRef } from "react";

export default function ScrollProgress() {
  const fillRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const fill = fillRef.current;
    if (!fill) return;

    const set = () => {
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - doc.clientHeight;
      const progress = scrollable > 0 ? doc.scrollTop / scrollable : 0;
      fill.style.transform = `scaleX(${Math.min(Math.max(progress, 0), 1)})`;
    };

    set();
    const onChange = () => requestAnimationFrame(set);
    window.addEventListener("scroll", onChange, { passive: true });
    window.addEventListener("resize", onChange);
    return () => {
      window.removeEventListener("scroll", onChange);
      window.removeEventListener("resize", onChange);
    };
  }, []);

  return (
    <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gray-200">
      {/* Initial scale must be inline: Tailwind v4's scale-* utilities set the
          standalone `scale` property, which multiplies with `transform` instead
          of being overridden by it. */}
      <div
        ref={fillRef}
        className="h-full w-full bg-blue-400 origin-left"
        style={{ transform: "scaleX(0)" }}
      />
    </div>
  );
}
